import { etiquetaDeEtapa } from '@/features/rh/lib/reclutamientoTablero'

/**
 * Devolver un descartado al tablero (SRH-320).
 *
 * La etapa ya no se elige: la calcula el servidor con el historial del
 * candidato y aquí solo se le dice a quien lo regresa donde va a caer.
 */

/**
 * Nombre de la etapa a la que vuelve, como se lo dice la pantalla.
 *
 * El cierre de selección no es una columna del tablero —se gestiona en su
 * propia pantalla—, así que «Aprobado por RH», que es donde lo pinta
 * `etiquetaDeEtapa`, no le diría a nadie dónde buscarlo.
 */
export const nombreDeLaEtapaDeRegreso = (stage?: string | null): string =>
  stage === 'pendiente_cierre' ? 'Cierre de selección' : etiquetaDeEtapa(stage)

/**
 * Las vacantes que se ofrecen al regresar a un descartado.
 *
 * Una con las plazas cubiertas sigue marcada como activa, pero ya no contrata:
 * es la que aparecía como cerrada en el selector. El servidor la rechaza
 * también; esto evita ofrecerla.
 */
export const vacantesParaRegresar = <T extends { plazasCubiertas?: boolean }>(
  vacantes: T[],
): T[] => vacantes.filter((vacante) => vacante.plazasCubiertas !== true)
